import { createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createWrapper } from 'next-redux-wrapper';
import { bindMiddleware } from '@gcloud-npm/next12.app-controller.store-utils';

import rootReducer from './reducers/index';
import rootSaga from './sagas/index';

export const makeStore = (/* context */) => {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    rootReducer(),
    bindMiddleware([sagaMiddleware])
  );

  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

export const wrapper = createWrapper(makeStore, { debug: false });
